module.exports = __webpack_public_path__ + "img/WTA.1266d191.png";